import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, unref } from 'vue'

import LButton from '@/components/core/Button.vue'
import FormGroup from '@/components/core/form/FormGroup.vue'
import LInput from '@/components/core/form/Input.vue'
import DateTimePicker from '@/components/core/DateTimePicker.vue'
import CommandLocationSearch from '@/components/core/CommandLocationSearch.vue'
import { useSelectedTrip } from '@/composables/trip'
import { useCreateRental, useUpdateRental } from '@/composables/transportation'
import { type Rental } from '@/types/transportation'
import { isPersistedRental } from '@/utils/transportation'
import { locationToAutocompleteResult } from '@/utils/location'

import { formatDateTime } from '@/utils/date-utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'RentalForm',
  props: {
    rental: { default: () => ({}) }
  },
  emits: ["saved", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'saved', rental: Rental): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { rental: Partial<Rental> };





const rental = ref<Partial<Rental>>(props.rental)

const internalPickupLocation = ref(
  rental.value.pickUpLocation
    ? locationToAutocompleteResult(rental.value.pickUpLocation)
    : undefined,
)

const internalDropOffLocation = ref(
  rental.value.dropOffLocation
    ? locationToAutocompleteResult(rental.value.dropOffLocation)
    : undefined,
)

const period = ref(rental.value.period ?? {})

const trip = useSelectedTrip()
const { mutateAsync: createRental, isLoading: isCreating } = useCreateRental(
  trip.value._id,
)
const { mutateAsync: updateRental, isLoading: isUpdating } = useUpdateRental(
  trip.value._id,
)
const isLoading = computed(() => isCreating.value || isUpdating.value)

async function handleSubmit() {
  const rentalPayload = unref(rental)
  rentalPayload.period = period.value

  if (isPersistedRental(rentalPayload)) {
    const updatedRental = await updateRental({
      ...rentalPayload,
      pickUpLocation: internalPickupLocation.value?.location,
      dropOffLocation: internalDropOffLocation.value?.location,
    })
    emit('saved', updatedRental)
  } else {
    const savedRental = await createRental({
      type: 'car',
      ...rentalPayload,
      pickUpLocation: internalPickupLocation.value?.location,
      dropOffLocation: internalDropOffLocation.value?.location,
    })
    emit('saved', savedRental)
  }
}

// Date validation functions ---------------------------------------------------

// Only allow start dates that are before or equal to the end date
function allowedStartDates(date: string) {
  return !period.value.end || date <= period.value.end
}

// Only allow end dates that are after or equal to the start date
function allowedEndDates(date: string) {
  return !period.value.start || date >= period.value.start
}

return { __sfc: true,props, emit, rental, internalPickupLocation, internalDropOffLocation, period, trip, createRental, isCreating, updateRental, isUpdating, isLoading, handleSubmit, allowedStartDates, allowedEndDates, LButton, FormGroup, LInput, DateTimePicker, CommandLocationSearch, formatDateTime }
}

})